export const formatDateAndHour = (dateString: string) => {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

export const formatDate = (dateString: string, withTime = false) => {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  const dateFormated = `${day}-${month}-${year}`;
  const dateWithTimeFormated = `${dateFormated} ${hours}:${minutes}`;

  return withTime ? dateWithTimeFormated : dateFormated;
};

export const formatDateToInput = (
  date: string | Date,
  withTime = false
): string =>
  typeof date === 'string'
    ? date.slice(0, withTime ? 16 : 10)
    : new Date(date).toISOString().slice(0, withTime ? 16 : 10);

export const formatTimeToInput = (date: string | Date): string =>
  typeof date === 'string'
    ? date.slice(10, 16)
    : new Date(date).toISOString().slice(11, 16);

export const formatDateToISOUTC = (dateString: string): string => {
  if (!dateString) return '';

  const date = new Date(dateString);
  return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
};
